module.exports = __webpack_public_path__ + "media/icons/numer_vin-8686ffba.svg";